export enum HelloSignWizardStep {
  FORM_STEP = 1,
  SUMMARY_STEP = 2,
}

// i.e 9175b5bc-c7b6-5650-9cbf-2c77a364f383
// i.e d7e7bf34-c23b-4a81-80ce-731f41b33088 (case insensitive)
export const UUID_REGEX =
  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
// i.e. ?query=param&another=param
export const QUERY_PARAM_REGEX = /(\?|&)([^=]+)=([^&]+)$/g;

export const PRODUCTS = {
  CASH_OFFER: 'Cash offer',
  CASH_PLUS: 'Cash Plus',
  // LIST_WITH_OPENDOR: 'List', // Needs to be localized: 'Poner a la venta'
} as const;

// from bricks novo theme
export const BOX_SHADOW_Z2 =
  '0px 10px 22px rgba(29, 71, 123, 0.08), 0px 2px 12px rgba(29, 71, 123, 0.08)';

export const MARKETING_SMS_CONSENT_CHECKBOX_LABEL =
  'I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase.';

// Consent language versioning for legal audit trail.
// The version key is logged downstream with each preference change so legal can
// reconstruct the exact copy a user saw at the time of consent.
//
// WHEN LEGAL UPDATES THE COPY:
//   1. Add a NEW entry to CONSENT_VERSIONS — do NOT edit or remove existing entries,
//      as those version keys may still be referenced in historical records.
//   2. Update CURRENT_CONSENT_VERSION to point to the new key.
//   3. Update MARKETING_SMS_CONSENT_CHECKBOX_LABEL above to match the new copy.
const CONSENT_VERSIONS = {
  marketing_sms_cake_v1: {
    checkboxLabel: MARKETING_SMS_CONSENT_CHECKBOX_LABEL,
  },
} as const;

type ConsentVersion = keyof typeof CONSENT_VERSIONS;

const CURRENT_CONSENT_VERSION: ConsentVersion = 'marketing_sms_cake_v1';

export const MARKETING_SMS_CONSENT = {
  version: CURRENT_CONSENT_VERSION,
  ...CONSENT_VERSIONS[CURRENT_CONSENT_VERSION],
};
